import { styled } from '@mui/material';
import { AppBar, Toolbar, Box } from '@sezzle/sezzle-mui';

import sezzleTheme from '../../../../packages/website/src/templates/Page/themes';

export const StyledAppBar = styled(AppBar)((props) => ({
  '&.MuiPaper-root': {
    boxShadow: sezzleTheme.colors.effects.dropShadowLight,
    paddingTop: props.theme.spacing(1),
    paddingBottom: props.theme.spacing(1),
  },
}));

export const StyledToolBar = styled(Toolbar)((props) => ({
  justifyContent: 'center',
}));

export const StyledAppBarMobileContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  overflow: 'hidden',
}));

export const StyledAppBarWebContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  maxWidth: 1600,
}));

export const StyledAppBarWebButtonsContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  overflow: 'hidden',
}));

export const StyledAppBarLogoWrapper = styled(Box)((props) => ({
  width: '15%',
  [props.theme.breakpoints.down('sm')]: { width: '50%' },
  [props.theme.breakpoints.down('xs')]: { width: '50%' },
  alignItems: 'center',
  height: 'auto',
}));

export const StyledAppBarLogoContainer = styled(Box)((props) => ({
  '& a': {
    display: 'block',
    maxHeight: 34,
    minHeight: 50,
    backgroundRepeat: 'no-repeat',
    zIndex: 1000,
    backgroundPosition: 'left center',
    backgroundSize: 130,
    [props.theme.breakpoints.down('sm')]: {
      backgroundSize: '100%',
      backgroundPosition: 'center',
    },
    [props.theme.breakpoints.down('xs')]: {
      backgroundSize: '100%',
      backgroundPosition: 'center',
    },
    [props.theme.breakpoints.down('md')]: { backgroundPosition: 'center' },
  },
  '& img': {
    maxHeight: 34,
    minHeight: 50,
  },
}));
